module.exports = __webpack_public_path__ + "components/patterns/locationsMap/map-cluster-medium.svg";